import { AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { Accordion } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type CrmAccordionProps = {
  children: any,
  title: string
}

export default function CrmAccordion({ children, title }: CrmAccordionProps) {
  return <Accordion sx={{ backgroundColor: "#FFF" }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ justifySelf: 'left' }} />}
      sx={{ justifyContent: 'flex-start', '.MuiAccordionSummary-content': { flexGrow: 'inherit' } }}
    >
      <Typography sx={{ flexShrink: 0 }} variant='h6' color='text.secondary'>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ backgroundColor: "#fff" }}>
      {children}
    </AccordionDetails>
  </Accordion>
}
